import { Component } from '@angular/core';
import { NgClass, NgForOf, NgIf } from '@angular/common';
@Component({
    selector: 'app-technologies',
    standalone: true,
    imports: [NgForOf, NgIf, NgClass],
    templateUrl: './technologies.component.html',
    styleUrls: ['./technologies.component.less'],
})
export class TechnologiesComponent {
    selectedTab = 'Front-end';

    tabs = ['Front-end', 'Back-end', 'Clouds', 'Design', 'Mobile'];

    technologies: Record<string, { name: string; icon: string; description: string }[]> = {
        'Front-end': [
            {
                name: 'React',
                icon: 'react',
                description: 'React, Next.js, React Router, Redux, Redux Toolkit, mobX, Zustand, Redux Thunk, Redux-Saga, RTK Query, React-Query, SWR, etc.',
            },
            {
                name: 'Angular',
                icon: 'angular',
                description: 'Angular, Angular material, KendoUI, Ant Design, PrimeNG, Bootstrap, DevExtreme, Nebular, Ag Grid, NgRx, NGXS, MobX, Akita, D3.js, etc.',
            },
            {
                name: 'Vue',
                icon: 'vuejs',
                description: 'Vue, NuxtJS, Quasar, Petite-vue, Vuex, Pinia, Vue Router, Vuetify, Element UI, PrimeVue, Vitest, Vue Test Utils, VueUse, Vue Query.',
            },
            {
                name: 'Vanilla js',
                icon: 'javascript',
                description: 'React, Angular, Vue, Vega, Svelte, Material, Ant Design, Bootstrap, Apollo GraphQL, Protractor, Cypress, Karma, Jasmine, Jest, Mocha, etc.',
            },
            {
                name: 'Vega',
                icon: 'vega',
                description: 'Vega, Next.js, Vega Codegen, etc.',
            },
        ],
        'Back-end': [
            {
                name: 'PHP',
                icon: 'php',
                description: 'DUKPT, Laravel, Symfony, MySQL, WordPress, Drupal, MongoDB, etc.',
            },
            {
                name: '.NET Core',
                icon: 'netcore',
                description: '.NET Core, ASP.NET Core MVC, ASP.NET Web API, ASP.NET, etc.',
            },
            {
                name: '.NET Framework',
                icon: 'netframework',
                description: 'ASP.NET Web Forms, ASP.NET MVC, Windows Forms, WPF, ADO.NET, Entity Framework, WCF, etc.',
            },
            {
                name: 'Node.js',
                icon: 'nodejs',
                description: 'NestJS, Ext JS, Express.js, Meteor.js, Koa, Electron, AWS, etc.',
            },
            {
                name: 'GO',
                icon: 'go',
                description: 'Go, GORM, Gin, protobuf, gRPC, AWS, GCP, Docker, Redis, etc.',
            },
            {
                name: 'Python',
                icon: 'python',
                description: 'Django, Flask, FastAPI, Pandas, NumPy, scikit-learn, TensorFlow, etc.',
            },
        ],
        Clouds: [
            { name: 'AWS', icon: 'aws', description: 'Amazon EC2, Amazon S3, Amazon RDS, Amazon DynamoDB, Amazon CloudFront, Amazon VPC, Amazon Lambda, etc.' },
            {
                name: 'Google Cloud',
                icon: 'googlecloud',
                description: 'Google Compute Engine, Google Cloud Storage, Google Cloud SQL, Google Cloud Functions, Google Kubernetes Engine, etc.',
            },
            {
                name: 'Azure',
                icon: 'azure',
                description: 'Azure Virtual Machines, Azure Blob Storage, Azure SQL Database, Azure Cosmos DB, Azure Functions, Azure Kubernetes Service, etc.',
            },
            {
                name: 'Docker',
                icon: 'docker',
                description: 'Docker Compose, Docker Swarm, Docker Hub, Docker Desktop, etc.',
            },
            {
                name: 'Terraform',
                icon: 'terraform',
                description: 'Terraform Registry, Terraform CLI, Terraform Cloud, Terraform Enterprise, etc.',
            },
            {
                name: 'Kubernetes',
                icon: 'kubernetes',
                description: 'Kubectl, Kustomize, Helm, etc.',
            },
        ],
        Design: [
            {
                name: 'Figma',
                icon: 'figma',
                description: 'We create static wireframes and mockups for websites and mobile apps by Figma.',
            },
            {
                name: 'WCAG Standard',
                icon: 'wcagstandard',
                description: 'We use WCAG standard to make Web content more accessible to people with disabilities.',
            },
            {
                name: 'Design System',
                icon: 'designsystem',
                description: 'Mature and standardized design component library brings unimaginable efficiency and uniformity',
            },
            {
                name: 'High-fidelity Prototype',
                icon: 'highfidelityprototype',
                description: 'High-fidelity prototypes bridge the gap between the design concept and the final product.',
            },
            {
                name: 'Multi-device Support',
                icon: 'multidevicesupport',
                description: 'We collaborate and brainstorm, provide a virtual whiteboard-like experience for teams by FigJam.',
            },
            {
                name: 'Responsive',
                icon: 'responsive',
                description: 'Design by grid structure to optimize website to communicate effectively and clearly.',
            },
        ],
        Mobile: [
            {
                name: 'IOS Native',
                icon: 'iosnative',
                description: 'Swift, Objective-C, VIPER, Clean Swift, MVP, MVVM, MVC, Composable, UIKit, etc.',
            },
            {
                name: 'Android Native',
                icon: 'androidnative',
                description: 'Kotlin, Java, Jetpack Compose, Coroutine, Android SDK, NDK, Room, Datastore, etc.',
            },
            {
                name: 'Flutter',
                icon: 'flutter',
                description: 'Dart, BLoC, RxDart, Provider, Riverpod, GetX, Clean Architecture, Modular, MobX, etc.',
            },
            {
                name: 'React Native',
                icon: 'reactnative',
                description: 'React, React-Native, React-Navigation, Expo, EAS, Redux, MobX, Zustand, etc.',
            },
            {
                name: 'Xamarin',
                icon: 'xamarin',
                description: 'Xamarin.Forms, C#, .NET, Visual Studio, MVVM, XAML, NuGet, Dependency Injection, etc.',
            },
            {
                name: '.NET MAUI',
                icon: 'netmaui',
                description: '.NET MAUI Blazor, .NET Core, REST/SOAP API backend, SQLite, XAML, Autofac.',
            },
        ],
    };

    selectTab(tab: string) {
        this.selectedTab = tab;
    }
}
